<template>
  <div>
    <div style="padding:20px;">
      <van-button style="margin:0 10px;padding: 0px 20px;" plain size="small" round type="primary" @click="copy(logs)">复制日志</van-button>
      <van-button style="margin:0 10px;padding: 0px 20px;" plain size="small" round type="warning" @click="clearLogs()">清空日志</van-button>
    </div>
    <div>{{logs}}</div>
  </div>
</template>
<script>
export default {
    data(){
        return{
            logs:''
        }
    },
    mounted(){
      document.title = '廉洁三一 日志'
      this.getLogs()
    },
    methods:{
      clearLogs(){
        localStorage.removeItem('ts_logs');
        this.getLogs()
      },
      getLogs(){
        this.logs = localStorage.getItem('ts_logs');
      },
      copy(text){
        var textarea = document.createElement('textarea');
        textarea.style.position = 'fixed';
        textarea.style.opacity = 0;
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$message.success('复制成功')
      }
    }
}
</script>